import withoutTrailingCharacters from "./withoutTrailingCharacters.js";
function withoutTrailingSlash(string) {
  return withoutTrailingCharacters(string, "/");
}
export {
  withoutTrailingSlash as default
};
//# sourceMappingURL=withoutTrailingSlash.js.map
